import React from 'react';
import { DEFAULT_PASS_BACKGROUND_COLOR } from '../../../shared/constants/loyalPassBrand';
import { QRCodeSVG } from 'qrcode.react';

export default function PassPreview({
    merchantName,
    programName,
    logoUrl,
    email,
    points = 0,
    visits = 0,
    brandColor,
    textColor,
}) {
    const qrValue = `${merchantName}-${email}`;

    return (
        <div
            className="w-full max-w-xs border border-gray-300 rounded-2xl shadow-lg p-4"
            style={{ backgroundColor: brandColor || DEFAULT_PASS_BACKGROUND_COLOR }}
        >
            {/* Top: Logo + Issuer */}
            <div className="flex items-center justify-start space-x-3 mb-4">
                {logoUrl ? (
                    <img src={logoUrl} alt="logo" className="w-10 h-10 rounded-full object-cover" />
                ) : (
                    <div className="w-20 h-20 bg-gray-200 rounded-full content-center text-sm text-gray-600 flex items-center justify-center">
                        Logo
                    </div>
                )}
                <span className="text-xl font-semibold" style={{ color: textColor || '#ffffff' }}>
                    {merchantName || 'Merchant Name'}
                </span>
            </div>

            {/* Program Title */}
            <h2 className="text-l font-bold text-left" style={{ color: textColor || '#ffffff' }}>
                {programName || 'Program Name'}
            </h2>

            {/* Points and Visits */}
            <div className="mt-2">
                <div className="flex justify-between">
                    <div className="flex flex-col items-start">
                        <p
                            className="text-sm font-medium"
                            style={{ color: textColor || '#ffffff' }}
                        >
                            Points
                        </p>
                        <p
                            className="text-lg font-semibold"
                            style={{ color: textColor || '#ffffff' }}
                        >
                            {points}
                        </p>
                    </div>
                    <div className="flex flex-col items-end">
                        <p
                            className="text-sm font-medium"
                            style={{ color: textColor || '#ffffff' }}
                        >
                            Visits
                        </p>
                        <p
                            className="text-lg font-semibold"
                            style={{ color: textColor || '#ffffff' }}
                        >
                            {visits}
                        </p>
                    </div>
                </div>
            </div>

            {/* QR Code */}
            <div className="flex justify-center my-4 rounded-lg p-2">
                <QRCodeSVG value={qrValue} size={128} />
            </div>

            {/* Customer email */}
            <p className="text-sm text-center" style={{ color: textColor || '#ffffff' }}>
                {email || 'customer@email.com'}
            </p>

            <p
                className="mt-3 text-center text-[10px] font-medium tracking-wide opacity-70"
                style={{ color: textColor || '#ffffff' }}
            >
                Powered by LoyalPass
            </p>
        </div>
    );
}
